import { render, staticRenderFns } from "./EmptyCart.vue?vue&type=template&id=9e19f654&scoped=true&"
import script from "./EmptyCart.vue?vue&type=script&lang=js&"
export * from "./EmptyCart.vue?vue&type=script&lang=js&"
import style0 from "./EmptyCart.vue?vue&type=style&index=0&id=9e19f654&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e19f654",
  null
  
)

/* custom blocks */
import block0 from "@/locales/empty_cart.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvar%2Fjenkins%2Fworkspace%2Fon-production-deploy%2Ffront%2Fcomponents%2FNavigation%2FMiniCart%2FEmptyCart%2FEmptyCart.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports